import {Accordion} from './modules/accordion';

function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
  
function addClassOnScroll() {
    var elements = document.querySelectorAll('.romb-block');
    var elements_list = document.querySelectorAll('.categories-item');

    elements.forEach(function(element) {
        if (isInViewport(element)) {
            element.classList.add('show');
        } 
    });

    elements_list.forEach(function(element) {
        if (isInViewport(element)) {
            element.classList.add('show');
        } 
    });
}
  
window.addEventListener('scroll', addClassOnScroll);
window.addEventListener('DOMContentLoaded', addClassOnScroll);


$(function(){
    let accordeon = new Accordion();
    
    $('.seo-toggler').on('click', function(){
        let textWrapper = $(this).closest('.seo-block').find('.seo-text');
        let overflowWrapper = $(this).closest('.seo-block').find('.seo-text-wrapper');
        let contentHeight = accordeon.getChildrenHeight(textWrapper);

        if($(this).hasClass('show')){
            $(this).removeClass('show')
            accordeon.accordeonAnimation(overflowWrapper, 75, 'hide')
        }else{
            $(this).addClass('show');
            $(this).hide();
            accordeon.accordeonAnimation(overflowWrapper, contentHeight, 'show')
        }
    })
})